import { render, staticRenderFns } from "./JobList.vue?vue&type=template&id=5b9a95e2"
import script from "./JobList.vue?vue&type=script&lang=js"
export * from "./JobList.vue?vue&type=script&lang=js"
import style0 from "./JobList.vue?vue&type=style&index=0&id=5b9a95e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports